import StickyNavBar from 'components/ProductPage/StickyNavBar/StickyNavBar';

export default StickyNavBar;
